// Vertical column chart: one bar per item scaled to the largest value, with the
// value above each bar and a short caption below.
import { Box, Flex, Text, useColorModeValue } from "@chakra-ui/react";

/**
 * Renders a single column: value on top, a proportional vertical bar, caption.
 * @param {Object} props - label, value, color, pct (bar height 0-100)
 * @returns {React.ReactElement}
 */
function Column({ label, value, color, pct }) {
  const captionColor = useColorModeValue("secondaryGray.600", "secondaryGray.400");
  return (
    <Flex direction="column" align="center" flex="1" minW="0" h="100%">
      <Text fontSize="sm" fontWeight="800" color={color} mb="6px">{value}</Text>
      <Flex flex="1" align="flex-end" w="100%" justify="center">
        <Box w="58%" maxW="22px" h={`${pct}%`} minH={pct > 0 ? "4px" : "0"} bg={color}
          borderTopRadius="6px" transition="height .4s ease" />
      </Flex>
      <Text fontSize="9px" color={captionColor} mt="6px" noOfLines={1}>{label}</Text>
    </Flex>
  );
}

/**
 * Renders items as vertical columns that fill the available height.
 * @param {Object} props - items ([{label, value, color}]) with resolved colors
 * @returns {React.ReactElement}
 */
export default function ColumnBars({ items }) {
  const max = Math.max(1, ...items.map((it) => it.value));
  return (
    <Flex flex="1" align="stretch" justify="space-between" gap="6px" w="100%" minH="150px" py="10px">
      {items.map((it, i) => (
        <Column key={i} {...it} pct={(it.value / max) * 100} />
      ))}
    </Flex>
  );
}
